export default "__VITE_ASSET__DpQVlQjZ__"